import './MenuFooter.scss';

import { useDispatch } from "react-redux";

import { openModal } from "../../../slices/modalSlice";

import SupportAgent from "@mui/icons-material/SupportAgent";
import NewReleases from "@mui/icons-material/NewReleases";

import HelpModal from "../../../help-modal/HelpModal";

import { MiddleTitle } from "../../../common-components/Titles/Titles";
import { MenuLink } from "../../../common-components/MenuLink/MenuLink";
import { TextButton } from "../../../common-components/Buttons/Buttons";

const MenuFooter = () => {
    const dispatch = useDispatch();

    const handleOpenModal = () => {
        dispatch(openModal({content: <HelpModal/>, closeable: true}));
    }

    return (
        <div className={"menu-footer"}>
            <div className={"menu-footer_title"}>
                <MiddleTitle property={"Прочее"}/>
            </div>
            <div className={"menu-footer_content"}>
                <TextButton Icon={SupportAgent} title={"Тех. поддержка"} active={true} onClick={handleOpenModal}/>
                <MenuLink Icon={NewReleases} title={"Что нового"} active={true} link={"https://resq.kz/resqcore_news"} show={true} />
            </div>
        </div>
    )
}

export default MenuFooter;